/**
 * Общие Tailwind-стили кнопок партнёрских ссылок (Stay/Trip и Booking).
 * Раньше getVariantStyles дублировался 1:1 в StayLinkButton и BookingLinkButton —
 * различались только бренд-цвета палитры.
 *
 * Важно: храним ПОЛНЫЕ class-строки на вариант (а не собираем цвет динамически),
 * иначе Tailwind JIT их не увидит и не сгенерирует.
 */

const BASE =
    'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

const VARIANTS = {
    // Trip.com / общая «синяя» палитра (бывш. StayLinkButton)
    trip: {
        primary: `${BASE} bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg focus:ring-blue-500`,
        secondary: `${BASE} bg-white hover:bg-gray-50 text-blue-600 border-2 border-blue-600 px-6 py-3 rounded-lg shadow-md hover:shadow-lg focus:ring-blue-500`,
        chip: `${BASE} bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-300 hover:border-gray-400 focus:ring-gray-500`,
        card: `${BASE} w-full h-full bg-white hover:bg-gray-50 text-gray-900 p-4 rounded-lg shadow-md hover:shadow-lg border border-gray-200 hover:border-gray-300 focus:ring-gray-500`,
        bare: '',
    },
    // Booking.com фирменная палитра #003580 (бывш. BookingLinkButton)
    booking: {
        primary: `${BASE} bg-[#003580] hover:bg-[#00224f] text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg focus:ring-[#003580]`,
        secondary: `${BASE} bg-white hover:bg-gray-50 text-[#003580] border-2 border-[#003580] px-6 py-3 rounded-lg shadow-md hover:shadow-lg focus:ring-[#003580]`,
        outline: `${BASE} bg-transparent hover:bg-[#003580]/10 text-white border-2 border-white px-6 py-3 rounded-lg focus:ring-white`,
        chip: `${BASE} bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-300 hover:border-gray-400 focus:ring-gray-500`,
        bare: '',
    },
};

/**
 * @param {string} variant — 'primary'|'secondary'|'chip'|'card'|'outline'|'bare'|...
 * @param {'trip'|'booking'} palette
 * @returns {string} полная class-строка варианта (BASE для неизвестного варианта)
 */
export function getProviderButtonStyles(variant = 'primary', palette = 'trip') {
    const map = VARIANTS[palette] || VARIANTS.trip;
    return map[variant] ?? BASE;
}
